const offcanvasMenu = () => {
  $('#offcanvas .menu-item-has-children').addClass('offcanvas-has-dropdown');
  $('#offcanvas')
    .find('li')
    .removeClass('menu-item-has-children');

  // Hover dropdown menu on mobile
  $('.offcanvas-has-dropdown').mouseenter(function () {

    $(this)
      .addClass('active')
      .find('ul')
      .slideDown(500, 'easeOutExpo');
  }).mouseleave(function () {

    $(this)
      .removeClass('active')
      .find('ul')
      .slideUp(500, 'easeOutExpo');
  });
};

const burger = () => {
  const $body = $('body');
  $body.on('click', '.js-nav-toggle', e => {
    const $this = $(this);

    if ($body.hasClass('offcanvas')) {
      $body.removeClass('offcanvas');
    } else {
      $body.addClass('offcanvas');
    }

    $this.toggleClass('active');

    e.preventDefault();
  });
};

// Should only be fired once since it listens on a window event
const closeMenuOnwindowResize = () => {
  const $body = $('body');

  $(window).resize(function () {
    if ($body.hasClass('offcanvas')) {
      $body.removeClass('offcanvas');
      $('.js-nav-toggle').removeClass('active');
    }
  });
};

// Mobile outside click close offcanvas
const closeMenuOnOutsideClick = function (modalSelector) {

  const clickHandler = function (e) {
    const container = $('#offcanvas, .js-nav-toggle');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      if ($('body').hasClass('offcanvas')) {
        $('body').removeClass('offcanvas');
        $('.js-nav-toggle').removeClass('active');
      }
    }
  };

  $(document).click(clickHandler);

  if(modalSelector){
    const $modal = $(modalSelector);

    // Removes click handler on document when the contact modal is opened
    $modal.on('show.bs.modal', function () {
      $(document).off('click', clickHandler);
    });

    // Registers the click handler again when the contact modal is closed
    $modal.on('hidden.bs.modal', function () {
      $(document).click(clickHandler);
    });
  }
};

const offcanvas = (offcanvasOption) => {
  offcanvasOption = offcanvasOption || {};

  burger();
  offcanvasMenu();
  closeMenuOnwindowResize();
  closeMenuOnOutsideClick(offcanvasOption.modalSelector);
}

export default offcanvas;



// WEBPACK FOOTER //
// ./scripts/util/offcanvas.js